import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {GRAY_DARKER} from 'ui-library/Colors';

interface StructurePredictionInfoProps {
  modelDisplayName: string;
  modelVersion: string;
  className?: string;
}

function StructurePredictionInfo({
  modelDisplayName,
  modelVersion,
  className,
}: StructurePredictionInfoProps): JSX.Element {
  return (
    <div className={classNames(css(styles.modelInfo), className)}>
      <div className={css(styles.modelDetail)}>
        <span className={css(styles.label)}>Model:</span>
        <span className={css(styles.value)}>{modelDisplayName}</span>
      </div>
      <div className={css(styles.modelDetail)}>
        <span className={css(styles.label)}>Version:</span>
        <span className={css(styles.value)}>{modelVersion}</span>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  modelInfo: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    margin: '0', // Remove bottom margin for better vertical centering
  },
  modelDetail: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  label: {
    ...FONT_PROXIMA_13,
    color: GRAY_DARKER,
    fontWeight: 'bold',
  },
  value: {
    ...FONT_PROXIMA_13,
    color: '#333',
  },
});

export default StructurePredictionInfo;
